
import React from "react";
import { Helmet } from 'react-helmet';
import { Link, useOutletContext } from "react-router-dom";

import Data_migration from "../../../Assets/Data_migration.png";
import WareHouse from "../../../Assets/WareHouse (2).png";
import Incident_mangemenet from "../../../Assets/Incident_mangement.png";
import ERP_tool from "../../../Assets/ERP_tool.png";
import { useScrollAnimation } from "../../../utils/Utils";
import About from "../../../Assets/AboutUspng.png"
import PurposeSection from "./AboutUs/OurOverview";
import Overview from "./AboutUs/Overview";
import WhyChoose from "./AboutUs/WhyChoose";
import CoreValues from "./AboutUs/CoreValues";
import WhatWeDo from "./AboutUs/WhatWeDo";
import LogosSection from "./AboutUs/Certifications";
import FinalCTA from "./AboutUs/CTA";
import Intro from "./AboutUs/AboutusIntro";

const AboutUs = () => {
  const { linkClicked } = useOutletContext();
  useScrollAnimation();
  return (
    <div>
      <Helmet>
        <title>About Kapil Technologies India | Leading IT Staffing & Consulting</title>
        <meta name="description" content="Learn about Kapil Technologies, India's leading IT staffing and consulting company. Discover our expertise in SAP, ERP solutions, and digital transformation services." />
        <meta name="keywords" content="About Kapil Technologies India, IT staffing company India, SAP consulting India, ERP solutions India, digital transformation India, technology consulting India, Kapil Technologies overview, IT services India, business solutions India, enterprise consulting India, technology experts India, Kapil Technologies history, IT innovation India, consulting services India, technology leadership India" />
        <meta name="author" content="Kapil Technologies" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="About Kapil Technologies India | Leading IT Staffing & Consulting" />
        <meta property="og:description" content="Learn about Kapil Technologies, India's leading IT staffing and consulting company. Discover our expertise in SAP and digital transformation." />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_IN" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Kapil Technologies India | Leading IT Staffing & Consulting" />
        <meta name="twitter:description" content="Learn about Kapil Technologies, India's leading IT staffing and consulting company." />
        <link rel="canonical" href="https://kapiltechnologies.com/insights/about-us" />
      </Helmet>
       {/* <div className="w-full h-auto max-w-full m-auto">
      <video 
        src="https://res.cloudinary.com/djaejg3nn/video/upload/v1781803479/aboutus_page_video_spqxhm.mp4"
        className="w-full max-h-[600px] object-contain" 
        preload="metadata" 
        autoPlay 
        muted 
          playsInline
          loop={true}
      >
        Your browser does not support the video tag.
      </video>
      </div> */}

      <Intro />
      <WhyChoose/>
      <CoreValues/>
      <WhatWeDo/>
      <LogosSection/>
      <FinalCTA/>
    </div>
  );
};

export default AboutUs;
